import React from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { CTAButton } from "@/components/common/CTA";
import { RouteLines } from "@/components/common/RouteLines";
import { waLink } from "@/config/site";
import { useSettings } from "@/context/SettingsContext";

export default function FinalCTA() {
  const { contact } = useSettings();
  return (
    <section className="relative bg-teal overflow-hidden" data-testid="final-cta">
      <RouteLines className="pointer-events-none absolute inset-0 h-full w-full opacity-20" stroke="#ffffff" opacity={0.5} />
      <div className="container-page relative py-20 lg:py-28 text-center flex flex-col items-center">
        <Reveal>
          <h2 className="font-heading font-bold tracking-tight text-white text-[30px] leading-[36px] md:text-[42px] md:leading-[48px] max-w-3xl">
            Your next supplier search starts with a clear requirement
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mt-5 text-[17px] leading-[28px] text-white/85 max-w-2xl">
            Send us the product details, quantity and destination. Our team will review the request
            and explain the next information or action required.
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
            <CTAButton to="/request-a-quote" className="bg-white text-teal hover:bg-white/90" icon={ArrowRight} data-testid="finalcta-primary">
              Submit your requirement
            </CTAButton>
            <CTAButton href={waLink(undefined, contact.whatsappNumber)} target="_blank" rel="noopener noreferrer" variant="ghostLight" icon={MessageCircle} data-testid="finalcta-whatsapp">
              Ask on WhatsApp
            </CTAButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
